// VW FONTSIZE
function coSetResponsiveFontSize() {
    const root = document.documentElement;
    const vw = window.innerWidth / 10;
    root.style.setProperty('--co-vw-font-size', `${vw}px`);
}
coSetResponsiveFontSize();

window.addEventListener('resize', coSetResponsiveFontSize);
//X VW FONTSIZE
// IMAGE LOADER
const coImagesGlobalLoader = document.querySelectorAll('img.co-img-loader');
coImagesGlobalLoader.forEach((img) => {
    const coHandleImageLoad = () => {
        img.classList.add("co-img-loaded");
    };
    if (img.complete) {
        img.classList.add("co-img-completed");
    } else {
        img.addEventListener('load', coHandleImageLoad);
    }
});
//X IMAGE LOADER